import { FC } from "react";
import cx from "classnames";
import MultiselectDropdown from "@app/shared/checkbox-dropdown/MultiselectDropdown";
import MultiselectNestedDropdown from "@app/shared/checkbox-dropdown/MultiselectNestedDropdown";
import { QESButton } from "@app/shared/qes-standards/Button";
import { QESTextInput } from "@app/shared/qes-standards/forms/TextInput";
import { ComplianceConnectFilterBarProps } from "@app/compliance-connect/common/complianceConnectFilterBarTypes";

function selectionText(selectedCount: number, totalCount: number): string {
    return `${selectedCount} of ${totalCount} options selected`;
}

export const ComplianceConnectFilterBar: FC<ComplianceConnectFilterBarProps> = (props) => {
    const {
        className,
        clearAllTestId,
        containerTestId,
        disabled,
        extraFilters,
        networkNameSearch,
        onClearAll,
        onSearch,
        onSpecialtiesChange,
        searchTestId,
        selectedSpecialties,
        serviceAreaTestId,
        specialtyOptions,
        specialtyTestId,
    } = props;

    const specialtySelectionText = selectionText(selectedSpecialties.length, specialtyOptions.length);

    return (
        <div className={cx("compliance-connect-filter-bar", className)} data-testid={containerTestId}>
            <div className="compliance-connect-filter-bar__inner">
                {networkNameSearch && (
                    <div className="compliance-connect-filter-bar__item">
                        <QESTextInput
                            label="Network Name"
                            onChange={(e) => networkNameSearch.onChange(e.target.value)}
                            placeholder={networkNameSearch.placeholder ?? "Search by network name"}
                            testId={networkNameSearch.testId}
                            value={networkNameSearch.value}
                        />
                    </div>
                )}

                {extraFilters}

                {props.serviceAreaVariant === "nested" ? (
                    <MultiselectNestedDropdown
                        containerClassName="compliance-connect-filter-bar__item"
                        customSelectInputText={selectionText(
                            props.selectedServiceAreas.length,
                            props.serviceAreaOptions.reduce((n, parent) => n + parent.children.length, 0),
                        )}
                        disabled={disabled}
                        items={props.serviceAreaOptions}
                        label="Service Area"
                        onSelectionChanged={props.onServiceAreasChange}
                        selectedItems={props.selectedServiceAreas}
                        showTooltipOnOverflow
                        testId={serviceAreaTestId}
                    />
                ) : (
                    <MultiselectDropdown<string>
                        containerClassName="compliance-connect-filter-bar__item"
                        customSelectInputText={selectionText(props.selectedServiceAreas.length, props.serviceAreaOptions.length)}
                        disabled={disabled}
                        items={props.serviceAreaOptions}
                        label="Service Area"
                        onSelectionChanged={props.onServiceAreasChange}
                        selectedItems={props.selectedServiceAreas}
                        showTooltipOnOverflow
                        testId={serviceAreaTestId}
                    />
                )}

                <MultiselectDropdown<string>
                    containerClassName="compliance-connect-filter-bar__item"
                    customSelectInputText={specialtySelectionText}
                    customWidth
                    disabled={disabled}
                    items={specialtyOptions}
                    label="Specialty"
                    onSelectionChanged={onSpecialtiesChange}
                    selectedItems={selectedSpecialties}
                    showTooltipOnOverflow
                    testId={specialtyTestId}
                />

                <div className="compliance-connect-filter-bar__actions">
                    <QESButton onClick={onSearch} qesTestId={searchTestId} qesType="outline">
                        Search
                    </QESButton>

                    <QESButton onClick={onClearAll} qesTestId={clearAllTestId} qesType="link">
                        Clear All
                    </QESButton>
                </div>
            </div>
        </div>
    );
};

export default ComplianceConnectFilterBar;
